import PropTypes from 'prop-types';

const RenderIf = props => {
	const {
		children,
		condition
	} = props;

	if(condition){
		return children;
	}

	return null;
};

RenderIf.propTypes = {
	condition: PropTypes.bool.isRequired,
	children: PropTypes.node,
};

export default RenderIf;
